const META_WORKFLOW_WEBHOOK = 'https://n8n.chatbotwhatsapp.com/webhook/setup-agent-workflows';

export interface AgentSetupResult {
  success: boolean;
  webhookUrl: string;
  webhookId: string;
  agentId: string;
  agenteWorkflowId: string;
  escalaWorkflowId: string;
}

export async function setupAgentWithWorkflows(
  businessName: string,
  instanceName: string,
  phoneNumber: string,
  userId: string,
  escalationPhone: string
): Promise<AgentSetupResult> {
  const response = await fetch(META_WORKFLOW_WEBHOOK, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ businessName, instanceName, phoneNumber, userId, escalationPhone }),
  });

  if (!response.ok) {
    throw new Error(`Error configurando agente: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
